import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout, Row, Col, Card } from 'antd';
import './AuthLayout.css';

const { Content } = Layout;

const AuthLayout = () => {
  return (
    <Layout className="auth-layout">
      <Content className="auth-content">
        <div className="auth-background">
          <Row justify="center" align="middle" className="auth-row">
            <Col xs={22} sm={16} md={12} lg={8} xl={6}>
              <Card className="auth-card">
                <div className="auth-header">
                  <div className="auth-logo">
                    <img
                      src="/images/LOGO-04.png"
                      alt="小金蝉"
                      className="logo-image"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <h1 className="logo-text">小金蝉</h1>
                  </div>
                  <p className="auth-subtitle">专业的一站式债权处置平台</p>
                </div>
                <div className="auth-form">
                  <Outlet />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default AuthLayout;